import { adminRoutes } from '@bettermode/domain/routes/web/admin'
import { T, useI18n } from '@tribeplatform/react-components/i18n'
import { useRouter } from '@tribeplatform/react-sdk'

import { TabHeader } from '../../TabView/index.js'

import { Domain } from './index.js'

export function DomainSectionRoute() {
  const { $t } = useI18n()

  return (
    <>
      <TabHeader
        title={$t({
          defaultMessage: 'Domain settings',
          id: 'Generics.DomainSettings',
        })}
        subtitle={$t({
          defaultMessage: 'Configure your community domain and URL settings.',
          id: 'Admin.DomainSettings.Description',
        })}
      />

      <div className="w-full flex px-3.5 py-5">
        <div className="max-w-3xl w-full">
          <Domain />
        </div>
      </div>
    </>
  )
}

export function DomainBreadCrumb() {
  const { Link } = useRouter()
  return (
    <Link href={adminRoutes.settings.domain}>
      <T id="Generics.Domain" defaultMessage="Domain" />
    </Link>
  )
}
